module.exports = __webpack_public_path__ + "img/delivery3.54760982.png";